import { useCallback, useState, useContext, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  OutlinedInput,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import FormContext from '../../contexts/form/formContext';
import Spinner from '../Layouts/Spinner';
import { AlertComp, ConfirmAlertComp } from '../Layouts/Alert';

const studentClassArr = [
  { class: 'PRIMARY 4', classId: 'p4' },
  { class: 'PRIMARY 5', classId: 'p5' },
  { class: 'PRIMARY 6', classId: 'p6' },
  { class: 'JSS 1', classId: 'j1' },
  { class: 'JSS 2', classId: 'j2' },
  { class: 'JSS 3', classId: 'j3' },
  { class: 'SSS 1', classId: 's1' },
  { class: 'SSS 2', classId: 's2' },
  { class: 'SSS 3', classId: 's3' },
];

const ITEM_HEIGHT = 43;
const ITEM_PADDING_TOP = 10;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StudentFormPage = ({ id }) => {
  const { addStudent, addCurrentCount, currentStudentCount } =
    useContext(FormContext);

  const [studentObj, setStudentObj] = useState({
    name: '',
    phone: '',
    age: '',
    email: '',
    studClass: '',
    gender: '',
    passport: '',
  });

  const { name, phone, email, age, studClass, gender, passport } = studentObj;

  const [readySubmit, setReadySubmit] = useState(false);

  const setValues = (e) => {
    setStudentObj({ ...studentObj, [e.target.name]: e.target.value });
  };

  const [alertMessage, setAlertMessage] = useState({
    alert: false,
    message: '',
    title: '',
  });

  const [confirmAlert, setConfirmAlert] = useState({
    title: '',
    message: '',
    active: false,
    confirmed: false,
  });

  const { active, confirmed } = confirmAlert;

  const submitStudent = () => {
    // try looping through the object
    if (
      name === '' &&
      age === '' &&
      gender === '' &&
      studClass === '' &&
      passport === ''
    ) {
      setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message:
          'Make sure to fill every field, But the email and phone number is optional for the student.',
      }));
    } else if (name === '') {
      setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message: "Please enter student's full name",
      }));
    } else if (gender === '') {
      setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message: 'Please select a gender for the student.',
      }));
    } else if (age === '') {
      setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message: "Please add student's age.",
      }));
    } else if (studClass === '') {
      setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message: 'Please select a class for the student.',
      }));
    } else if (passport === '') {
      setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message: 'Add a passport for the student.',
      }));
    } else if (phone !== '' && phone.length < 11) {
      setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message: 'Invalid phone number, check the number again.',
      }));
    } else {
      setConfirmAlert({
        title: 'Are you sure?',
        message:
          "Are you sure you want to add this student?. After adding this student you can't edit it again.",
        active: true,
        confirmed: false,
      });
    }
  };

  useEffect(() => {
    if (confirmed) {
      const valObj = { name, gender, studClass, passport, age };
      if (email) valObj.email = email;
      if (phone) valObj.phone = phone;

      setReadySubmit(true);
      addStudent(valObj);
      addCurrentCount(currentStudentCount + 1);
    }
    //eslint-disable-next-line
  }, [confirmed]);

  return (
    <>
      <div className="w-full mt-8">
        {alertMessage.alert && (
          <AlertComp
            alertMessage={alertMessage}
            setAlertMessage={setAlertMessage}
          />
        )}

        {active && (
          <ConfirmAlertComp
            confirmAlert={confirmAlert}
            setConfirmAlert={setConfirmAlert}
          />
        )}
        <h4 className="text-2xl font-medium my-3 text-cyan-500">
          PASSPORT FOR STUDENT <span className="text-3xl">{id + 1}</span>
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <input
            type="text"
            name="name"
            readOnly={readySubmit}
            value={name}
            onChange={setValues}
            className="bg-stone-50 rounded-lg p-3"
            placeholder="Full name"
          />

          <NumberFormat
            format={'##'}
            className="bg-stone-50 rounded-lg p-3"
            placeholder="Age"
            onChange={(e) =>
              setStudentObj({
                ...studentObj,
                age: e.target.value.replace(/\s/g, ''),
              })
            }
            readOnly={readySubmit}
            value={age}
          />
          {/*  */}
          <FormControl
            className={
              'w-full cursor-pointer rounded-lg py-auto px-4 border-none'
            }
          >
            <InputLabel id="demo-multiple-name-label">
              Select student's class
            </InputLabel>
            <Select
              readOnly={readySubmit}
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              className={'rounded-md h-full bg-stone-50'}
              value={studClass}
              onChange={(e) =>
                setStudentObj({ ...studentObj, studClass: e.target.value })
              }
              input={<OutlinedInput label="Select student's class" />}
              MenuProps={MenuProps}
            >
              {studentClassArr.map((count) => (
                <MenuItem key={count.classId} value={count.class}>
                  {count.class}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/*  */}
          <GenderSelect
            gender={gender}
            setValues={setValues}
            readySubmit={readySubmit}
          />
          {/*  */}
          <Uploadcomp
            setStudentObj={setStudentObj}
            passport={passport}
            readySubmit={readySubmit}
          />
        </div>
        <br />
        <button
          className={`p-2 font-medium rounded-lg w-full ${
            readySubmit === true
              ? 'bg-slate-300 opacity-30 hidden'
              : 'bg-green-400 hover:bg-green-500'
          }`}
          onClick={submitStudent}
          disabled={readySubmit}
        >
          I have uploaded passport for this student
        </button>
      </div>
    </>
  );
};

const Uploadcomp = ({ setStudentObj, passport, readySubmit }) => {
  const [imageNum, setImageNum] = useState(false);

  const [loading, setLoading] = useState(false);
  const onDrop = useCallback((files) => {
    if (files.length === 0) {
      return setImageNum(true);
    }

    setImageNum(false);
    const formData = new FormData();

    formData.append('file', files[0]);
    formData.append('upload_preset', 'pmbfgbns');

    setLoading(true);

    uploadImage(formData);
    //eslint-disable-next-line
  }, []);

  const uploadImage = async (formData) => {
    try {
      const res = await axios.post(
        'https://api.cloudinary.com/v1_1/diuvrqrde/image/upload',
        formData
      );
      const data = res.data.url;
      if (data) {
        setStudentObj((prevState) => ({
          ...prevState,
          passport: data,
        }));
        setLoading(false);
      }
    } catch (err) {
      alert('Something went wrong, try again');
      setLoading(false);
      console.log(err);
    }
  };

  const { getRootProps, getInputProps, isDragActive, isDragReject } =
    useDropzone({
      onDrop,
      maxFiles: 1,
      accept: {
        'image/*': ['.jpeg', '.jpg', '.png'],
      },
    });
  return (
    <>
      {loading ? (
        <div className="text-2xl text-blue-500 md:col-span-2">
          <Spinner />
        </div>
      ) : (
        <>
          {!readySubmit && (
            <div
              {...getRootProps()}
              className="border border-slate-600 p-10 mt-10 cursor-pointer rounded-lg bg-slate-100 md:col-span-2"
            >
              <input {...getInputProps()} />
              {isDragReject && (
                <p className="text-red-500">File type not accepted</p>
              )}
              {imageNum && (
                <p className="my-5 text-red-500">Select only one image</p>
              )}
              {isDragActive ? (
                <p>Drop the files here ...</p>
              ) : (
                <div>
                  <p className="hidden md:block">
                    DRAG AND DROP PASSPORT HERE, OR CLICK TO ADD PASSPORT
                  </p>
                  <p className="block md:hidden">
                    <span className="p-3 rounded-md bg-amber-300">
                      {passport === '' ? 'Add passport' : 'Change Passport'}
                    </span>
                  </p>
                </div>
              )}
            </div>
          )}
          {passport !== '' && (
            <div className="md:col-span-2 w-full h-40">
              <img
                src={`${passport}`}
                className="mx-auto rounded-lg h-full"
                alt="passport"
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

const GenderSelect = ({ setValues, gender, readySubmit }) => {
  // const [gender, setGender] = useState('')
  return (
    <>
      <div className="bg-stone-50 rounded-lg">
        <FormControl>
          <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="gender"
            value={gender}
            onChange={setValues}
          >
            <FormControlLabel
              value="female"
              name="gender"
              control={<Radio />}
              label="Female"
              disabled={readySubmit}
            />
            <FormControlLabel
              value="male"
              name="gender"
              control={<Radio />}
              label="Male"
              disabled={readySubmit}
            />
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
};

export default StudentFormPage;
